export default __webpack_public_path__ + "static/media/play-btn.218ac5a1.svg";